const rowsPerPageOptions = [5, 10, 25, 50];
const rowsPerPageOptions3x = [6, 9, 12, 24, 48];

/** Shared loading messages for FullScreenOverlayLoader. */
const LOADING_MESSAGES = {
  WEEKLY_PATROL_REPORT: "Loading weekly patrol report...",
  GPS_DATA: "Loading GPS data...",
  DEFAULT: "Loading...",
  UPLOADING_DOCUMENT: "Uploading Document ...",
  PROCESSING_IMAGE: "Processing image...",
  STARTING_CAMERA: "Starting Camera ..."
};

export default {
  rowsPerPageOptions,
  rowsPerPageOptions3x,
  LOADING_MESSAGES
};
